import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import Logger from '../services/logger';
import AuthorizationContext from './AuthorizationContext';
import EmployerContext from './EmployerContext';

const PendoContext = React.createContext({});

export const PendoContextProvider = PendoContext.Provider;

export const PendoContextConsumer = PendoContext.Consumer;

const getPendo = () => window?.pendo;

const isPendoLoaded = () => !!window?.pendo;

const isPendoAlreadyInitialized = () => {
    const pendo = getPendo();
    return pendo?.isReady && pendo?.isReady();
};

const initPendoForUser = ({ user, employer }) => {
    try {
        if (!isPendoLoaded()) {
            return;
        }

        if (isPendoAlreadyInitialized()) {
            Logger.info('[PendoService.initPendoForUser] Pendo is already initialized!');
            return;
        }

        if (!(user && employer)) {
            Logger.info('[PendoService.initPendoForUser] Missing user or employer data, cannot identify user!');
            return;
        }

        getPendo().initialize({
            visitor: {
                id: user.origUserPrefs._id,
                email: user.email,
                name: user.name,
                roles: user.roles,
                createdAt: user.created_at,
            },
            account: {
                id: employer._id,
                name: employer.name,
                resellerEmployerId: employer.resellerEmployerId,
                resellerCompanyId: employer.resellerCompanyId,
                atsType: employer.settings.atsType,
                createdAt: employer.created,
            },
        });

        Logger.info(`[PendoService.initPendoForUser] Init pendo finished for => ${user.email}`);
    } catch (err) {
        Logger.error(`[PendoService.initPendoForUser] Pendo error: ${err.message}`);
    }
};

export const PendoApp = withRouter(({ children }) => {
    const { user } = useContext(AuthorizationContext);
    const { employer } = useContext(EmployerContext);

    useEffect(() => {
        initPendoForUser({ user, employer });
    }, [user, employer]);

    return (
        <PendoContextProvider value={{}}>
            {children}
        </PendoContextProvider>
    );
});

export default PendoContext;
